/* istanbul ignore file */
import DocumentsForm from './DocumentsForm';

export default DocumentsForm;
